import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { BarElement, CategoryScale, Chart as Chartjs, LinearScale } from "chart.js";

Chartjs.register(BarElement, LinearScale, CategoryScale)
const VarBarChart = ({ reportExtractData, fundName }) => {

    var data = {
        labels: reportExtractData?.header2?.map(x => x),
        datasets: [
            {
                label: fundName + '-' + "Equity",
                data: reportExtractData?.totals?.map(y => y),
                backgroundColor: ["rgb(139, 251, 232, 0.9)"],
            }]
    }
    var options = {
        indexAxis: 'x',
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                ticks: {
                    font: {
                        size: 10,
                    },
                    grid: {
                        display: false,
                    },
                }
            },
            y: {
                ticks: {
                    font: {
                        size: 10,
                    }
                },
                grid: {
                    display: false,
                },
            },
        },
        plugins: {
            legend: {
                position: 'bottom',
            }
        },
    }
    return (
        <div className="col-lg-12">
            <Bar data={data} height={750} width={50} options={options} />
        </div>
    );
};

export default VarBarChart;
